/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GameHealthFeature
 */
export interface GameHealthFeature {
    /**
     * Internal GEP feature name (e.g., "match_info", "kill_feed"). Map to a player-friendly label on the client.
     * @type {string}
     * @memberof GameHealthFeature
     */
    feature: string;
    /**
     * 
     * @type {number}
     * @memberof GameHealthFeature
     */
    eventCount: number;
}

/**
 * Check if a given object implements the GameHealthFeature interface.
 */
export function instanceOfGameHealthFeature(value: object): value is GameHealthFeature {
    if (!('feature' in value) || value['feature'] === undefined) return false;
    if (!('eventCount' in value) || value['eventCount'] === undefined) return false;
    return true;
}

export function GameHealthFeatureFromJSON(json: any): GameHealthFeature {
    return GameHealthFeatureFromJSONTyped(json, false);
}

export function GameHealthFeatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): GameHealthFeature {
    if (json == null) {
        return json;
    }
    return {
        
        'feature': json['feature'],
        'eventCount': json['eventCount'],
    };
}

export function GameHealthFeatureToJSON(json: any): GameHealthFeature {
    return GameHealthFeatureToJSONTyped(json, false);
}

export function GameHealthFeatureToJSONTyped(value?: GameHealthFeature | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'feature': value['feature'],
        'eventCount': value['eventCount'],
    };
}

